export const userActionStartByApiCallEventName = 'faroApiCall';
export const userActionStart = 'user_action_start';
export var UserActionSeverity;
(function (UserActionSeverity) {
    UserActionSeverity["Normal"] = "normal";
    UserActionSeverity["Critical"] = "critical";
})(UserActionSeverity || (UserActionSeverity = {}));
//# sourceMappingURL=const.js.map